<template>
  <div class="mt-5">
    <br />
    <br />
    <br />
    <div class="row">
      <div class="col-12 mb-2">
        <button @click="refresh()" class="btn ms-auto btn0 btn-secondary">
          <i class="bi bi-arrow-clockwise"></i>
        </button>
      </div>
    </div>

    <!-- <div  class="row align-items-stretch text-secondary">
      <div class="col-12 col-xl-3 p-3">
        <div class="row align-items-center py-1 border rounded bg-white">
          <div class="col-1">
            <i class="bi bi-cart3 text-primary" :style="{ fontSize: '30px !important' }"></i>
          </div>
          <div class="col-11">
            <div class="text-center">Commandes du jour</div>
            <div class="text-center">
              <span v-if="totalTodays.orders" class="text-primary fw-bold">
                {{ totalTodays.orders.totalOrders }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 col-xl-3 p-3">
        <div class="row align-items-center py-1 border rounded bg-white">
          <div class="col-1">
            <i class="bi bi-window-x text-warning" :style="{ fontSize: '30px !important' }"></i>
          </div>
          <div class="col-11">
            <div class="text-center">En attente de livraison</div>
            <div class="text-center">
              <span v-if="totalTodays.orders" class="text-warning fw-bold">
                {{ totalTodays.orders.pendingDeliveryOrders }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 col-xl-3 p-3">
        <div class="row align-items-center py-1 border rounded bg-white">
          <div class="col-1">
            <i class="bi bi-window-dash text-danger" :style="{ fontSize: '30px !important' }"></i>
          </div>
          <div class="col-11">
            <div class="text-center">En attente de validation</div>
            <div class="text-center">
              <span v-if="totalTodays.orders" class="text-danger fw-bold">
                {{ totalTodays.orders.pendingValidationOrders }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 col-xl-3 p-3">
        <div class="row align-items-center py-1 border rounded bg-white">
          <div class="col-1">
            <i class="bi bi-cash-stack text-success" :style="{ fontSize: '30px !important' }"></i>
          </div>
          <div class="col-11">
            <div class="text-center">Commandes validées</div>
            <div class="text-center">
              <span v-if="totalTodays.orders" class="text-success fw-bold">
                {{ totalTodays.orders.completedOrders }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div  class="row align-items-stretch text-secondary">
      <div class="col-12 col-xl-3 p-3">
        <div class="row align-items-center py-1 border rounded bg-white">
          <div class="col-1">
            <i class="bi bi-cart3 text-primary" :style="{ fontSize: '30px !important' }"></i>
          </div>
          <div class="col-11">
            <div class="text-center">Total commandes</div>
            <div class="text-center">
              <span v-if="totalTodays.orders" class="text-primary fw-bold">
                {{ totalTodays.orders.totalOrdersAll }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 col-xl-3 p-3">
        <div class="row align-items-center py-1 border rounded bg-white">
          <div class="col-1">
            <i class="bi bi-window-x text-warning" :style="{ fontSize: '30px !important' }"></i>
          </div>
          <div class="col-11">
            <div class="text-center">Total en attente de livraison</div>
            <div class="text-center">
              <span v-if="totalTodays.orders" class="text-warning fw-bold">
                {{ totalTodays.orders.pendingDeliveryOrdersAll }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 col-xl-3 p-3">
        <div class="row align-items-center py-1 border rounded bg-white">
          <div class="col-1">
            <i class="bi bi-window-dash text-danger" :style="{ fontSize: '30px !important' }"></i>
          </div>
          <div class="col-11">
            <div class="text-center">Total en attente de validation</div>
            <div class="text-center">
              <span v-if="totalTodays.orders" class="text-danger fw-bold">
                {{ totalTodays.orders.pendingValidationOrdersAll }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 col-xl-3 p-3">
        <div class="row align-items-center py-1 border rounded bg-white">
          <div class="col-1">
            <i class="bi bi-cash-stack text-success" :style="{ fontSize: '30px !important' }"></i>
          </div>
          <div class="col-11">
            <div class="text-center">Total commandes validées</div>
            <div class="text-center">
              <span v-if="totalTodays.orders" class="text-success fw-bold">
                {{ totalTodays.orders.completedOrdersAll }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div> -->
  <div v-if="allTotals.warnings" class="alert alert-danger" role="alert">
    
      <div v-for="warning in allTotals.warnings" class="w-100" v-html="warning">
        
      </div>
  </div>

    <div class="row align-items-stretch text-secondary">

  <!-- Crédit Clients -->
<div class="col-12 col-xl-2 p-3" v-if="$userRole == 'Admin'">
  <div class="row align-items-center dashboard-card border bg-light-primary">
    <div class="col-1">
      <i class="bi bi-people-fill dashboard-icon text-primary"></i>
    </div>
    <div class="col-11 text-center">
      <div>Crédit Clients</div>
      <span v-if="allTotals.sales" class="text-gray fw-bold">
        {{ allTotals.sales.totalUnpaidSale | formatWithSpaces }}
      </span>
    </div>
  </div>
</div>

<!-- Paiements -->
<div class="col-12 col-xl-2 p-3" v-if="$userRole == 'Admin'">
  <div class="row align-items-center dashboard-card border bg-light-secondary">
    <div class="col-1">
      <i class="bi bi-receipt-cutoff dashboard-icon text-primary"></i>
    </div> 
    <div class="col-11 text-center">
      <div>Paiements</div>
      <span v-if="allTotals.payments" class="text-success fw-bold">
        + {{ allTotals.payments.totalPaidSale | formatWithSpaces }}
      </span>
    </div>
  </div>
</div>

<!-- Dépenses -->
<div class="col-12 col-xl-2 p-3" v-if="$userRole == 'Admin'">
  <div class="row align-items-center dashboard-card border bg-light-warning">
    <div class="col-1">
      <i class="bi bi-wallet2 dashboard-icon text-warning"></i>
    </div>
    <div class="col-11 text-center">
      <div>Dépenses</div>
      <span v-if="allTotals.expenses" class="text-danger fw-bold">
        - {{ allTotals.expenses.priceTotalTTCExpense | formatWithSpaces }}
      </span>
    </div>
  </div>
</div>

<!-- Virements (Total) -->
<div class="col-12 col-xl-2 p-3" v-if="$userRole == 'Admin'">
  <div class="row align-items-center dashboard-card border bg-light-danger">
    <div class="col-1">
      <i class="bi bi-arrow-left-right dashboard-icon text-danger"></i>
    </div>
    <div class="col-11 text-center">
      <div>Virements (Total)</div>
      <span v-if="allTotals.transactions" class="text-danger fw-bold">
        - {{ allTotals.transactions.totalTransaction | formatWithSpaces }}
      </span>
    </div>
  </div>
</div>

<!-- Virements Fonds de Caisse -->
<div class="col-12 col-xl-2 p-3" v-if="$userRole == 'Admin'">
  <div class="row align-items-center dashboard-card border bg-light-warning">
    <div class="col-1">
      <i class="bi bi-cash-coin dashboard-icon text-warning"></i>
    </div>
    <div class="col-11 text-center">
      <div>Fonds de Caisse</div>
      <span v-if="allTotals.transactions" class="text-warning fw-bold">
        {{ allTotals.transactions.totalCashFundTransaction | formatWithSpaces }}
      </span>
    </div>
  </div>
</div>

<!-- Virements Hors Caisse -->
<div class="col-12 col-xl-2 p-3" v-if="$userRole == 'Admin'">
  <div class="row align-items-center dashboard-card border bg-light-secondary">
    <div class="col-1">
      <i class="bi bi-bank dashboard-icon text-secondary"></i>
    </div>
    <div class="col-11 text-center">
      <div>Virements</div>
      <span v-if="allTotals.transactions" class="text-secondary fw-bold">
        - {{ allTotals.transactions.totalTransactionWithoutCashFund | formatWithSpaces }}
      </span>
    </div>
  </div>
</div>

<!-- Caisse -->
<div class="col-12 col-xl-2 p-3" v-if="$userRole == 'Admin' || $userRole == 'Caissier'">
  <div class="row align-items-center dashboard-card border bg-light-success">
    <div class="col-1">
      <i class="bi bi-cash-coin dashboard-icon text-success"></i>
    </div>
    <div class="col-11 text-center">
      <div>Caisse</div>
      <span v-if="allTotals.checkout" class="text-secondary text-decoration-underline fw-bold">
        {{ allTotals.checkout.amountAtCheckout | formatWithSpaces }}
      </span>
    </div>
  </div>
</div>

<!-- Caisse Dépenses -->
<div class="col-12 col-xl-2 p-3" v-if="$userRole == 'Admin' || $userRole == 'Caissier'">
  <div class="row align-items-center dashboard-card border bg-light-success">
    <div class="col-1">
      <i class="bi bi-cart-dash dashboard-icon text-warning"></i>
    </div>
    <div class="col-11 text-center">
      <div>Caisse Dépenses</div>
      <span v-if="allTotals.checkout" class="text-secondary text-decoration-underline fw-bold">
        {{ allTotals.checkout.amountAtCheckoutExpence | formatWithSpaces }}
      </span>
    </div>
  </div>
</div>

<!-- Paiement Matière -->
<div class="col-12 col-xl-2 p-3" v-if="$userRole == 'Admin'">
  <div class="row align-items-center dashboard-card border bg-light-secondary">
    <div class="col-1">
      <i class="bi bi-box-seam dashboard-icon text-info"></i>
    </div>
    <div class="col-11 text-center">
      <div>Paiement Matière</div>
      <span v-if="allTotals.rawMaterials" class="text-danger fw-bold">
        - {{ allTotals.rawMaterials.totalPaidRawMaterial | formatWithSpaces }}
      </span>
    </div>
  </div>
</div>

<!-- Total Matière -->
<div class="col-12 col-xl-2 p-3" v-if="$userRole == 'Admin'">
  <div class="row align-items-center dashboard-card border bg-light-primary">
    <div class="col-1">
      <i class="bi bi-boxes dashboard-icon text-primary"></i>
    </div>
    <div class="col-11 text-center">
      <div>Total Matière</div>
      <span v-if="allTotals.rawMaterials" class="text-dark fw-bold">
        {{ allTotals.rawMaterials.priceTotalTTCRawMaterial | formatWithSpaces }}
      </span>
    </div>
  </div>
</div>

<!-- Résultat : Marge -->
<div class="col-12 col-xl-2 p-3" v-if="$userRole == 'Admin'">
  <div class="row align-items-center dashboard-card border bg-light-info">
    <div class="col-1">
      <i class="bi bi-graph-up-arrow dashboard-icon text-info"></i>
    </div>
    <div class="col-11 text-center">
      <div>Résultat (Marge)</div>
      <span v-if="allTotals.results" class="text-success fw-bold">
        {{ allTotals.results.winMarge | formatWithSpaces }} dh
      </span>
    </div>
  </div>
</div>

<!-- Moyenne Marge Mensuelle -->
<div class="col-12 col-xl-2 p-3" v-if="$userRole == 'Admin'">
  <div class="row align-items-center dashboard-card border bg-light-dark">
    <div class="col-1">
      <i class="bi bi-calendar2-check-fill dashboard-icon text-dark"></i>
    </div>
    <div class="col-11 text-center">
      <div>Marge Moyenne / Mois</div>
      <span v-if="allTotals.results" class="text-secondary fw-bold">
        {{ allTotals.results.moyenneWinMarge | formatWithSpaces }} dh
      </span>
    </div>
  </div>
</div>

</div>

    <br>
    <br>
    <br>

    <div  class="row" v-if="$userRole == 'Admin'">
      <div class="col-xl-6 col-12 p-1">
        <table class="table table-striped table-hover">
          <thead>
            <tr>
              <th scope="col" class="text-center" colspan="4">
                Top 10 clients avec crédits impayés
              </th>
            </tr>
            <tr>
              <th scope="col"></th>
              <th scope="col"></th>
              <th scope="col" class="text-center">

              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(credit, index) in top10Credits" :key="index++">
              <td>
                {{ index }}
              </td>

              <td>
                <span v-if="credit">
                  {{ credit.customerFullName }}
                </span>
              </td>
              <td class="text-end">
                <span class="text-danger fw-bold">

                  {{
                  parseFloat(credit.totalUnpaid).toFixed(2) | formatWithSpaces
                  }}

                </span>
              </td>


            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td></td>
              <td></td>
              <td class="text-end">
                <span class="text-end bg-danger rounded px-2 py-1 text-white">
                  {{ parseFloat(top10TotalUnpaidSum).toFixed(2) | formatWithSpaces }}
                </span>
              </td>
              <td class="d-xl-flex d-none"></td>
            </tr>
          </tfoot>
        </table>
      </div>
      <div class="col-xl-6 col-12 row p-1">
        <div class="col-8 mx-auto">
          <vue-pie-chart :chart-data="pieChartData"  />
        </div>
      </div>
    </div>

    <div  class="row " v-if="$userRole == 'Admin'">

      <div class="col-xl-3 align-items-stretch text-secondary p-2 " 
      v-for="(section, index) in sections" :key="index">
        <div class="shadow rounded p-3 h-100">
          <div class="row" v-for="(item, itemIndex) in section.items" :key="itemIndex">
            <div class="col">
              {{ item.label }}
            </div>
            <div class=" col-auto">
              <span v-if="totalTodays[section.key]" :class="item.color">
                {{ totalTodays[section.key][item.value] | formatWithSpaces }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <br />
    <br />
    <div class="shadow p-3 border" v-if="$userRole == 'Admin'">
      <center class="fw-bold">
      Rapport d’Achat et de Vente Prévisionnelle
    </center>
    <hr>
    <div class="row mb-3">
  <div class="col">
    <label>De</label>
    <input type="date" v-model="filter.startDate" class="form-control" />
  </div>
  <div class="col">
    <label>À</label>
    <input type="date" v-model="filter.endDate" class="form-control" />
  </div>
  <div class="col">
    <label>Marge (Dh)</label>
    <input type="text" v-model="filter.winMarge" class="form-control" />
  </div>
  <div class="col d-flex align-items-end">
    <button class="btn btn-primary w-100" @click="filterRawMaterialReport(filter)">
      Rechercher
    </button>
  </div>
</div>

<vue-data-table 
  :headers="headers" 
  :data="rawMaterialReport" 
  :items-per-page="10" 
  :buttons="buttons"
  :summable-columns="summableColumns"
>

  <!-- Qté Brute -->
  <template #cell-totalQuantity="{ row }">
    <span v-if="row.totalQuantity" class="px-2 py-1 rounded bg-light-secondary text-dark">
      {{ row.totalQuantity | formatWithSpaces }} kg
    </span>
    <span v-else>

    </span>
  </template>

  <!-- Total TTC -->
  <template #cell-totalPriceTTC="{ row }">
    <span v-if="row.totalQuantity" class="px-2 py-1 rounded bg-light-warning text-dark fw-bold">
      {{ row.totalPriceTTC | formatWithSpaces }} dh
    </span>
    <span v-else>

    </span>
  </template>

  <!-- Prix unitaire TTC -->
  <template #cell-unitPrice="{ row }">
    <span v-if="row.totalQuantity" class="px-2 py-1 rounded"
      :class="row.unitPrice > 0 ? 'bg-light-success text-success' : 'bg-light-danger text-danger'">
      {{ row.unitPrice | formatWithSpaces }} dh
    </span>
    <span v-else>

    </span>
  </template>

  <!-- Qté Nette -->
  <template  #cell-netQuantity="{ row }">
    <span v-if="row.totalQuantity" class="px-2 py-1 rounded bg-light-info text-dark">
      {{ row.netQuantity | formatWithSpaces }} kg
    </span>
    <span v-else>

    </span>
  </template>

  <!-- Ventes Totales TTC -->
  <template #cell-totalSales="{ row }">
    <span class="px-2 py-1 rounded bg-light-warning text-dark fw-bold">
      {{ row.totalSales | formatWithSpaces }} dh
    </span>
  </template>

  <!-- Ventes Totales KG -->
  <template #cell-dailySalesQty="{ row }">
    <span class="px-2 py-1 rounded bg-light-secondary text-dark">
      {{ row.dailySalesQty | formatWithSpaces }} kg
    </span>
  </template>

  <!-- Prix Vente KG -->
  <template #cell-unitSalePrice="{ row }">
    <span class="px-2 py-1 rounded bg-light-success text-success">
      {{ row.unitSalePrice | formatWithSpaces }} dh
    </span>
  </template>

  <!-- Marge Brute -->
  <template #cell-grossMargin="{ row }">
    <span class="px-2 py-1 rounded"
      :class="row.grossMargin >= 0 ? 'bg-light-success text-success' : 'bg-light-danger text-danger'">
      {{ row.grossMargin | formatWithSpaces }} dh
    </span>
  </template>

  <!-- Stock Restant -->
  <template #cell-remainingStock="{ row }">
    <span class="px-2 py-1 rounded"
      :class="row.remainingStock >= 0 ? 'bg-light-primary text-primary' : 'bg-light-danger text-danger'">
      {{ row.remainingStock | formatWithSpaces }} kg
    </span>
  </template>

  <!-- Stock Initial -->
  <template #cell-previousStock="{ row }">
    <span class="px-2 py-1 rounded bg-light-info text-dark">
      {{ row.previousStock | formatWithSpaces }} kg
    </span>
  </template>

</vue-data-table>


    </div>

    
    <br />
    <br />

    <div class="row p-1" v-if="$userRole == 'Admin'">
      <div class="col-6">
        <div class="row align-items-end">
          <div class="col-xl-4">
            <label for="">Du</label>
            <input type="date" v-model="filter.startDate" class="form-control">
          </div>
          <div class="col-xl-4">
            <label for="">Au</label>
            <input type="date" v-model="filter.endDate" class="form-control">
          </div>

          <div class="col-xl-4">
            <label for=""></label>
            <button @click="filterQuantityData(filter)" class="btn btn-secondary">
              Rechercher
            </button>
          </div>
        </div>
        <br>
        <table class="table table-striped table-hover">
          <thead>
            <tr>
              <th scope="col" class="text-center" colspan="4">
                Suivre les quantités vendues pour chaque article
              </th>
            </tr>
            <tr>
              <th scope="col"></th>
              <th scope="col"></th>
              <th scope="col">Production</th>
              <th scope="col">Vendue</th>
              <th scope="col">Stock</th>
            </tr>
          </thead>
          <tbody>
            <!-- <tr v-for="(quantity, index) in quantityAnalytics" :key="index++"> -->
            <tr
  v-for="(quantity, index) in [...quantityAnalytics]
    .filter(q => !['CRÉDIT', 'UNDEFINED'].includes(q.fullName))
    .sort((a, b) => parseFloat(b.stockQuantity) - parseFloat(a.stockQuantity))"
  :key="index"
>
  <td>
    {{ index + 1 }}
  </td>

  <td>
    {{ quantity.fullName }}
  </td>

  <td class="text-center text-success px-3">
    + {{ parseFloat(quantity.productedQuantity).toFixed(3) }}
  </td>

  <td class="text-center text-danger px-3">
    - {{ parseFloat(quantity.soldQuantity).toFixed(3) }}
  </td>

  <td class="text-center px-3">
    {{ parseFloat(quantity.stockQuantity).toFixed(3) }}
  </td>
</tr>

          </tbody>

        </table>

      </div>
      <div class="col-6">
       <div class="">
      

        <div class="row align-items-end">
          <div class="col-xl-4">
            <label for="">Du</label>
            <input type="date" v-model="filter.startDate" class="form-control">
          </div>
          <div class="col-xl-4">
            <label for="">Au</label>
            <input type="date" v-model="filter.endDate" class="form-control">
          </div>

          <div class="col-xl-4">
            <label for=""></label>
            <button @click="filterCheckoutTransactions(filter)" class="btn btn-secondary">
              Rechercher
            </button>
          </div>
        </div>
        <br>
        <!-- Transactions Table -->
        <div class="">
          <div class="card-header">
            <h5 class="mb-0">
              <i class="fas fa-list-alt mr-2"></i>
              Caisse 
              <small class="text-muted ml-2" v-if="checkoutTransactions && checkoutTransactions.summary">
                ({{ checkoutTransactions.summary.transactionCount | formatWithSpaces }} transactions)
              </small>
            </h5>
          </div>
          <div class="card-body">
            <div class="table-responsive">
              <table class="table table-striped table-hover" v-if="checkoutTransactions && checkoutTransactions.transactions && checkoutTransactions.transactions.length > 0">
                <thead class="thead-dark">
                  <tr>
                    <th scope="col">Date</th>
                    <th scope="col">Type</th>
                    <th scope="col">Description</th>
                    <th scope="col">Amount</th>
                    <th scope="col">Balance</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="transaction in checkoutTransactions.transactions" :key="transaction.reference">
                    <td>
                      <small>{{ (transaction.date) }}</small>
                    </td>
                    
                    <td>
                      <span class="" :class="(transaction.type)">
                        {{ transaction.type }}
                      </span>
                    </td>
                    <td>
                      <small>{{ transaction.description }}</small>
                    </td>
                    
                    <td class="text-right">
                      <span :class="transaction.sign === '+' ? 'text-success' : 'text-danger'">
                        <strong>{{ transaction.sign }}{{ (transaction.amount) | formatWithSpaces }}</strong>
                      </span>
                    </td>
                    <td class="text-right">
                      <span :class="transaction.balance >= 0 ? 'text-success' : 'text-danger'" class="font-weight-bold">
                        {{ (transaction.balance) | formatWithSpaces  }}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
              
              <!-- Empty State -->
              <div v-else class="text-center py-5">
                <i class="fas fa-inbox fa-3x text-muted mb-3"></i>
                <p class="text-muted">No checkout transactions available</p>
              </div>
            </div>
          </div>
          
          <!-- Card Footer with Date Range -->
          <div class="card-footer text-muted" v-if="checkoutTransactions && checkoutTransactions.summary">
            <small>
              <i class="fas fa-calendar-alt mr-1"></i>
              Period: {{ (checkoutTransactions.summary.filterStartDate) }} - {{ (checkoutTransactions.summary.filterEndDate) }}
            </small>
          </div>
        </div>
      </div>
      </div>
    </div>
    <br />

  </div>
</template>
<script>
import { mapGetters } from "vuex";
import BarChartVue from "../components/chart/BarChart.vue";
import ScatterChart from "../components/chart/ScatterChart.vue";
import moment from "moment";
export default {
  components: {
    BarChartVue,
    ScatterChart,
  },
  data() {
    return {
      sections: [
        {
          key: 'sales',
          items: [
            { label: 'Total Ventes Aujourd\'hui', icon: 'bi bi-cart3', value: 'priceTotalTTCSale', color: 'text-primary' },
            { label: 'Total Ventes Payé', icon: 'bi bi-window-x', value: 'totalPaidSale', color: 'text-success' },
            { label: 'Total Ventes Impayé', icon: 'bi bi-window-dash', value: 'totalUnpaidSale', color: 'text-danger' },
            { label: 'Règlement Ventes Impayé', icon: 'bi bi-cash-stack', value: 'totalPaidOldBillSale', color: 'text-warning' },
            { label: 'Ventes Payé Espèces', icon: 'bi bi-cash', value: 'totalCashSale', color: 'text-success' },
            { label: 'Ventes Payé Virements', icon: 'bi bi-bank', value: 'totalBankTransferSale', color: 'text-danger' },
            { label: 'Ventes Payé Chèques', icon: 'bi bi-cash-coin', value: 'totalCheckSale', color: 'text-warning' },
          ]
        },
        {
          key: 'purchases',
          items: [
            { label: 'Total Achats d\'aujourd\'hui', icon: 'bi bi-cart3', value: 'priceTotalTTCPurchase', color: 'text-primary' },
            { label: 'Total Achats Payé', icon: 'bi bi-window-x', value: 'totalPaidPurchase', color: 'text-success' },
            { label: 'Total Achats Impayé', icon: 'bi bi-window-dash', value: 'totalUnpaidPurchase', color: 'text-danger' },
            { label: 'Règlement Achats Impayé', icon: 'bi bi-cash-stack', value: 'totalPaidOldBillPurchase', color: 'text-warning' },
            { label: 'Achats Payé Espèces', icon: 'bi bi-cash', value: 'totalCashPurchase', color: 'text-success' },
            { label: 'Achats Payé Virements', icon: 'bi bi-bank', value: 'totalBankTransferPurchase', color: 'text-danger' },
            { label: 'Achats Payé Chèques', icon: 'bi bi-cash-coin', value: 'totalCheckPurchase', color: 'text-warning' },
          ]
        },
        {
          key: 'expenses',
          items: [
            { label: 'Total Dépenses Aujourd\'hui', icon: 'bi bi-cart3', value: 'priceTotalTTCExpense', color: 'text-primary' },
            { label: 'Dépenses Payé Espèces', icon: 'bi bi-cash', value: 'totalCashExpense', color: 'text-success' },
            { label: 'Dépenses Payé Virements', icon: 'bi bi-bank', value: 'totalBankTransferExpense', color: 'text-danger' },
            { label: 'Dépenses Payé Chèques', icon: 'bi bi-cash-coin', value: 'totalCheckExpense', color: 'text-warning' },
          ]
        },
        {
          key: 'transactions',
          items: [
            { label: 'Total Transactions Aujourd\'hui', icon: 'bi bi-receipt', value: 'priceTotalTTCTransaction', color: 'text-primary' },
            { label: 'Transactions Payé Espèces', icon: 'bi bi-cash', value: 'totalCashTransaction', color: 'text-success' },
            { label: 'Transactions Payé Virements', icon: 'bi bi-bank', value: 'totalBankTransferTransaction', color: 'text-danger' },
            { label: 'Transactions Payé Chèques', icon: 'bi bi-cash-coin', value: 'totalCheckTransaction', color: 'text-warning' },
          ]
        },
      ],
      filter: {
        startDate: "",
        endDate: "",
        winMarge:5
      },

     headers: [
  { field: "supplierName", label: "Fournisseur", class: "" },
  { field: "date", label: "Date", class: "" },
  { field: "totalQuantity", label: "Qté Brute", class: "" },
  { field: "totalPriceTTC", label: "Total TTC", class: "" },
  { field: "unitPrice", label: "Prix KG", class: "" },
  { field: "netQuantity", label: "Qté Nette", class: "" },
  { field: "totalSales", label: "Ventes Totales (dh)", class: "" },
  { field: "dailySalesQty", label: "Ventes Totales KG", class: "" },
  { field: "unitSalePrice", label: "Prix Vente KG", class: "" },
  { field: "grossMargin", label: "Marge Brute", class: "" },      
  { field: "remainingStock", label: "Stock Restant", class: "" } , 
  { field: "previousStock", label: "Stock Initail", class: "" }  
]
,


      buttons: [
        
      ],
      summableColumns: [
        { field: "totalQuantity", },
        { field: "totalPriceTTC",},
        { field: "totalSales",},
        { field: "netQuantity",},
        { field: "grossMargin",},
      ]

    };
  },
  computed: {
    ...mapGetters("statistic", {
      totalTodays: "getTotalTodays",
      allTotals: "getTotals",
      // barTodaysChartData: "getBarTodaysChartData",
      quantityAnalytics: "getQuantityAnalytics",
      checkoutTransactions: "getCheckoutTransactions",
      rawMaterialReport: "getRawMaterialReport",
    }),

    ...mapGetters("credit", {
      credits: "getCredits",

    }),
    ...mapGetters("sale", {
      invoices: "getAll",
    }),

   
   pieChartData() {
  let paid = 0;
  let unpaid = 0;

  this.invoices.forEach(inv => {
    const amountPaid = parseFloat(inv.amountPaid) || 0;
    const amountUnpaid = parseFloat(inv.amountUnpaid) || 0;

    paid += amountPaid;
    unpaid += amountUnpaid;
  });

  return {
    labels: ["Payé", "Impayé"],
    datasets: [
      {
        backgroundColor: ['#4CAF50', '#F44336'],
        data: [paid, unpaid]
      }
    ]
  };
},


    pieChartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            position: 'bottom'
          }
        }
      };
    },




    top10Credits() {
      if (!this.credits) return [];
      var sortedCredits = this.credits.sort((a, b) => b.totalUnpaid - a.totalUnpaid);
      return sortedCredits.slice(0, 10);
    },
    top10TotalUnpaidSum() {
      if (!this.top10Credits) return 0;
      return this.top10Credits.reduce((acc, credit) => acc + credit.totalUnpaid, 0);
    },

  },
  async mounted() {
    await this.$store.dispatch("statistic/fetchCheckoutTransactions");
    await this.$store.dispatch("statistic/fetchTotalTodays");
    await this.$store.dispatch("statistic/fetchTotals");
    await this.$store.dispatch("statistic/fetchQuantityAnalytics", moment(new Date()).format("YYYY-MM-DD"));
    await this.$store.dispatch("credit/getAll");
    await this.$store.dispatch("statistic/fetchRawMaterialReport",{});
    await this.$store.dispatch("sale/filter", {});
  },
  methods: {
    async refresh() {
       await this.$store.dispatch("statistic/fetchCheckoutTransactions");
      await this.$store.dispatch("statistic/fetchTotals");
      await this.$store.dispatch("statistic/fetchTotalTodays");
      await this.$store.dispatch(
        "statistic/fetchQuantityAnalytics",
        moment(new Date()).format("YYYY-MM-DD")
      );
      await this.$store.dispatch("credit/getAll");
      await this.$store.dispatch("statistic/fetchRawMaterialReport",{});
      await this.$store.dispatch("sale/filter", {});

    },
    async filterQuantityData(filter) {
      await this.$store.dispatch("statistic/fetchQuantityAnalytics", filter);
    },

    async filterCheckoutTransactions(filter) {
      await this.$store.dispatch("statistic/fetchCheckoutTransactions", filter);
    },
    async filterRawMaterialReport(filter) {
      await this.$store.dispatch("statistic/fetchRawMaterialReport",filter);
    }
  },
  filters: {
    formatWithSpaces(value) {
      // Ensure the value is a number and fix it to 2 decimal places
      const fixedValue = Number(value).toFixed(2);
      // Convert the fixed number to a string and apply spaces as thousands separators
      return fixedValue.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    },
  },

};
</script>

<style>
  /* === Dashboard Cards Styles === */
  .dashboard-card {
    border-radius: 1rem;
    padding: 0.75rem;
    transition: all 0.3s ease-in-out;
  }

  .dashboard-card:hover {
    transform: translateY(-3px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }

  /* Icons */
  .dashboard-icon {
    font-size: 30px !important;
    line-height: 1;
  }

  /* Background variants */
  .bg-light-success {
    background-color: #e9f7ef !important;
  }

  .bg-light-warning {
    background-color: #fff8e6 !important;
  }

  .bg-light-danger {
    background-color: #fdecea !important;
  }

  .bg-light-primary {
    background-color: #e7f1ff !important;
  }

  .bg-light-secondary {
    background-color: #f5f6fa !important;
  }
</style>
